import { Howl, Howler } from 'howler'

const mainSounds = {
  starting: null,
  spinning: null,
  ending: null,
  short: null,
  correctGuess: null,
  wrongGuess: null,
}
const testSounds = {
  starting: null,
  spinning: null,
  ending: null,
}
const sounds = {}

const DEFAULT_VOLUME = 0.4
Howler.volume(DEFAULT_VOLUME) // this is relative to individual sound volume
export let isSpinningSoundRepeat = false // repeat means the same sound will play again when passing each pie

export const startingSounds = [
  { name: 'No Sound', src: 'no-sound' },
  {
    name: 'Button [Default]',
    src: 'button-sound',
    file: 'starting/Button.mp3',
  },
  {
    name: 'Cassette Button',
    src: 'cassette-button',
    file: 'starting/Cassette-Button.mp3',
  },
]

export const spinningSounds = [
  { name: 'No Sound', src: 'no-sound' },
  {
    name: 'Tick (Repeat) [Default]',
    src: 'tick-sound',
    file: 'spinning/Tick.mp3',
    repeat: true,
    volume: 0.2,
  },
  {
    name: 'Tick 2 (Repeat)',
    src: 'tick-2',
    file: 'spinning/Tick-2.mp3',
    repeat: true,
    volume: 0.3,
  },
  {
    name: 'Echo (Repeat)',
    src: 'echo',
    file: 'spinning/Echo.mp3',
    repeat: true,
    volume: 0.1,
  },
  {
    name: 'Water Drop (Repeat)',
    src: 'water-drop',
    file: 'spinning/Water-Drop.mp3',
    repeat: true,
    volume: 0.1,
  },
  {
    name: 'Kiss Swooch (Repeat)',
    src: 'kiss-smooch',
    file: 'spinning/Kiss-Smooch.mp3',
    repeat: true,
    volume: 0.1,
  },
  {
    name: 'Sword Attack (Repeat)',
    src: 'sword-attack',
    file: 'spinning/Sword-Attack.mp3',
    repeat: true,
    volume: 0.1,
  },
  {
    name: 'Happy Excited',
    src: 'happy-excited',
    file: 'spinning/Happy-Excited.mp3',
    volume: 0.2,
  },
  {
    name: 'Happy Excited Urban',
    src: 'happy-excited-urban',
    file: 'spinning/Happy-Excited-Urban.mp3',
    volume: 0.2,
  },
  {
    name: 'Happy Birthday',
    src: 'happy-birthday',
    file: 'spinning/Happy-Birthday.mp3',
    volume: 0.2,
  },
  {
    name: 'Christmas Ukulele',
    src: 'christmas-ukulele',
    file: 'spinning/Christmas-Ukulele.mp3',
    volume: 0.2,
  },
  {
    name: 'Chinese New Year',
    src: 'chinese-new-year',
    file: 'spinning/Chinese-New-Year.mp3',
    volume: 0.2,
  },
  {
    name: 'Yeah Baby',
    src: 'yeah-baby',
    file: 'spinning/Yeah-Baby.mp3',
    volume: 0.2,
  },
  {
    name: 'All My Love',
    src: 'all-my-love',
    file: 'spinning/All-My-Love.mp3',
    volume: 0.2,
  },
  {
    name: 'Kid Joy 1',
    src: 'kid-joy-1',
    file: 'spinning/Kid-Joy-1.mp3',
    volume: 0.2,
  },
  {
    name: 'Kid Joy 2',
    src: 'kid-joy-2',
    file: 'spinning/Kid-Joy-2.mp3',
    volume: 0.2,
  },
  {
    name: 'Halloween Spooky',
    src: 'halloween-spooky',
    file: 'spinning/Halloween.mp3',
    volume: 0.2,
  },
  {
    name: 'Lo Fi Boom Bap',
    src: 'lo-fi-boom-bap',
    file: 'spinning/Lo-Fi-Boom-Bap.mp3',
    volume: 0.2,
  },
  {
    name: 'Modern Pop Guitar',
    src: 'modern-pop-guitar',
    file: 'spinning/Modern-Pop-Guitar.mp3',
    volume: 0.2,
  },
  {
    name: 'Raining Socks',
    src: 'raining-socks',
    file: 'spinning/Raining-Socks.mp3',
    volume: 0.2,
  },
]

export const endingSounds = [
  { name: 'No Sound', src: 'no-sound' },
  {
    name: 'Celebration [Default]',
    src: 'celebration-sound',
    file: 'ending/Celebration.mp3',
  },
  {
    name: 'Announcement',
    src: 'short-announcement-sound',
    file: 'ending/ShortAnnounce.mp3',
  },
  {
    name: 'Bling',
    src: 'bling',
    file: 'ending/Bling.mp3',
  },
  {
    name: 'Ta Da',
    src: 'ta-da',
    file: 'ending/Ta-Da.mp3',
  },
  {
    name: 'Ta Da Funny',
    src: 'ta-da-funny',
    file: 'ending/Ta-Da-Funny.mp3',
  },
  {
    name: 'Notification',
    src: 'notification',
    file: 'ending/Notification.mp3',
  },
  {
    name: 'Kid Wow',
    src: 'kid-wow',
    file: 'ending/Kid-Wow.mp3',
  },
  {
    name: 'Long Kiss Smooch',
    src: 'kiss-smooch',
    file: 'ending/Kiss-Smooch.mp3',
  },
  {
    name: 'Opening Champagne',
    src: 'opening-champagne',
    file: 'ending/Opening-Champagne.mp3',
  },
  {
    name: 'Party Cheer',
    src: 'party-cheer',
    file: 'ending/Party-Cheer.mp3',
  },
  {
    name: 'Spear Attack',
    src: 'spear-attack',
    file: 'ending/Spear-Attack.mp3',
  },
  {
    name: 'Merry Christmas',
    src: 'merry-christmas',
    file: 'ending/Merry-Christmas.mp3',
  },
  {
    name: 'Car Horn Funny',
    src: 'car-horn-funny',
    file: 'ending/Car-Horn-Funny.mp3',
  },
  {
    name: 'Adventure Start',
    src: 'adventure-horn',
    file: 'ending/Adventure-Horn.mp3',
  },
  {
    name: 'Trumpet Announcement',
    src: 'trumpet-announcement',
    file: 'ending/Trumpet-Announcement.mp3',
  },
  {
    name: 'Boom Impact',
    src: 'boom-impact',
    file: 'ending/Boom-Impact.mp3',
  },
  {
    name: 'Magic Wind',
    src: 'magic-wind',
    file: 'ending/Magic-Wind.mp3',
  },
  {
    name: 'Soft Piano',
    src: 'soft-piano',
    file: 'ending/Soft-Piano.mp3',
  },
]

const shortAnnouncementSound = endingSounds[2]

export const preloadShortAnnouce = () => {
  try {
    preloadFile(shortAnnouncementSound.file, 'short')
  } catch (error) {
    console.log(error)
  }
}

const correctGuessSound = endingSounds[4]
const wrongGuessSound = endingSounds[5]

export const preloadGuessSounds = () => {
  try {
    preloadFile(shortAnnouncementSound.file, 'short')
    preloadFile(correctGuessSound.file, 'correctGuess')
    preloadFile(wrongGuessSound.file, 'wrongGuess')
  } catch (error) {
    console.log(error)
  }
}

export const preloadSound = (tempSound, where) => {
  let arraySounds = []
  switch (where) {
    case 'starting':
      arraySounds = startingSounds
      break
    case 'spinning':
      arraySounds = spinningSounds
      break
    case 'ending':
      arraySounds = endingSounds
      break
  }
  try {
    if (!tempSound.includes('http')) {
      const filteredSound = arraySounds.find(sound => sound.src == tempSound)
      preloadFile(
        filteredSound.file,
        where,
        filteredSound.repeat ? true : false,
        filteredSound.volume ? filteredSound.volume : DEFAULT_VOLUME,
      )
    } else {
      preloadFile(tempSound, where, false, DEFAULT_VOLUME, true)
    }
  } catch (error) {
    console.log(error)
  }
}

// export const preloadSounds = (startingSound, spinningSound, endingSound) => {
//   try {
//     preloadFile(
//       startingSounds.find(sound => sound.src == startingSound).file,
//       'starting',
//     )

//     const filteredSpinningSound = spinningSounds.find(
//       sound => sound.src == spinningSound,
//     )
//     preloadFile(
//       filteredSpinningSound.file,
//       'spinning',
//       filteredSpinningSound.repeat ? true : false,
//       filteredSpinningSound.volume ? filteredSpinningSound.volume : 1.0,
//     )

//     preloadFile(
//       endingSounds.find(sound => sound.src == endingSound).file,
//       'ending',
//     )
//   } catch (error) {
//     console.log(error)
//   }
// }

const preloadFile = (
  file,
  where,
  repeat = false,
  volume = DEFAULT_VOLUME,
  fromCustom = false,
) => {
  if (file) {
    if (!sounds[file]) {
      if (!where) return
      if (!fromCustom) {
        // import(`../../audio/${file}`).then(importedFile => {
        //have to give a static prefix "../../audio/" in order to works.
        sounds[file] = new Howl({
          //change using direct link
          src: [`/audio/${file}`],
          volume: volume,
        })
        mainSounds[where] = sounds[file]
      } else {
        sounds[file] = new Howl({
          src: [file],
          volume: volume,
          format: ['ogg'],
          html5: true,
        })
        mainSounds[where] = sounds[file]
      }
    } else {
      // to check same sound file for hide choice and add count action, and input change during spinning, ensure music play continually not restarting.
      if (mainSounds[where] !== sounds[file]) {
        if (mainSounds[where].playing()) {
          mainSounds[where].stop() // to make sure previous sound stop
        }
        mainSounds[where] = sounds[file]
        mainSounds[where].stop()
      } else {
        if (where === 'spinning') {
          if (mainSounds[where].playing()) {
            mainSounds[where].stop()
          }
        }
      }
    }
    if (where === 'spinning') {
      isSpinningSoundRepeat = repeat
    }
  } else {
    mainSounds[where] = null
  }
  // return null
}

export const playSound = (where, needLoop = false) => {
  if (mainSounds[where] !== null) {
    if (where === 'spinning') {
      if (isSpinningSoundRepeat) {
        mainSounds[where].currentTime = 0 //to reset to zero for repeat sound
      }

      if (needLoop) {
        mainSounds[where].loop(true)
      }
    } else if (where === 'short') {
      if (mainSounds['ending'] === null) {
        return //to check ending sound if it is null, if yes the skip playing, for rng
      }
    }
    mainSounds[where].play()
  }
}

export const pauseSound = where => {
  //only used for no repeat spinning sound
  if (mainSounds[where] !== null) {
    const tempVolume = mainSounds[where].volume()
    mainSounds[where].fade(tempVolume, 0, 500)
    mainSounds[where].on('fade', () => {
      mainSounds[where].pause()
      mainSounds[where].volume([tempVolume])
    })
  }
}

export const stopSound = where => {
  if (mainSounds[where] !== null) {
    mainSounds[where].stop()
  }
}

export const unmuteAllSounds = () => {
  const keys = Object.keys(mainSounds)
  keys.forEach(key => {
    if (mainSounds[key] !== null) {
      mainSounds[key].mute(false)
    }
  })
}

export const preloadTestSound = (tempSound, where, oldUrl = null) => {
  let arraySounds = []
  switch (where) {
    case 'starting':
      arraySounds = startingSounds
      break
    case 'spinning':
      arraySounds = spinningSounds
      break
    case 'ending':
      arraySounds = endingSounds
      break
  }
  try {
    if (!tempSound.includes('http') && !tempSound.includes('data:')) {
      const filteredSound = arraySounds.find(sound => sound.src == tempSound)
      preloadTestFile(
        filteredSound.file,
        where,
        filteredSound.volume ? filteredSound.volume : DEFAULT_VOLUME,
      )
    } else {
      if (oldUrl) {
        delete sounds[oldUrl]
      }
      preloadTestFile(tempSound, where, DEFAULT_VOLUME, true)
    }
  } catch (error) {
    console.log(error)
  }
}

// export const preloadTestSounds = (
//   startingSound,
//   spinningSound,
//   endingSound,
// ) => {
//   try {
//     preloadTestFile(
//       startingSounds.find(sound => sound.src == startingSound).file,
//       'starting',
//     )
//     const filteredSpinningSound = spinningSounds.find(
//       sound => sound.src == spinningSound,
//     )
//     preloadTestFile(
//       filteredSpinningSound.file,
//       'spinning',
//       filteredSpinningSound.volume ? filteredSpinningSound.volume : 1.0,
//     )
//     preloadTestFile(
//       endingSounds.find(sound => sound.src == endingSound).file,
//       'ending',
//     )
//   } catch (error) {
//     console.log(error)
//   }
// }

const preloadTestFile = (
  file,
  where,
  volume = DEFAULT_VOLUME,
  fromCustom = false,
) => {
  if (file) {
    if (!sounds[file]) {
      if (!where) return
      if (!fromCustom) {
        // import(`../../audio/${file}`).then(importedFile => {
        //have to give a static prefix "../../audio/" in order to works.
        sounds[file] = new Howl({
          //change using direct link
          src: [`/audio/${file}`],
          volume: volume,
        })
        testSounds[where] = sounds[file]
        // })
      } else {
        sounds[file] = new Howl({
          src: [file],
          volume: volume,
          format: ['ogg'],
          html5: true,
        })
        testSounds[where] = sounds[file]
      }
    } else {
      testSounds[where] = sounds[file]
    }
  } else {
    testSounds[where] = null
  }
  // return null
}

export const playTestSound = (where, callback = () => {}) => {
  if (testSounds[where] !== null) {
    testSounds[where].stop()
    if (testSounds[where].loop()) {
      testSounds[where].loop(false)
    }
    testSounds[where].play()
    testSounds[where].once('end', () => {
      callback()
    })
  } else {
    setTimeout(() => {
      callback()
    }, 50)
  }
}

export const stopTestSound = where => {
  if (testSounds[where] !== null) {
    testSounds[where].stop()
  }
}
